import "./PropertyBadge.css";

import { MODALITY_PROPERTY, NULL_GROUP_LABEL } from "../../../constants";
import { Badge } from "reactstrap";
import PropTypes from "prop-types";
import { PropertyName } from "../../PropertyName/PropertyName";
import { truncateNumber } from "../../../services/utils";
import { useGetPropertyCategory } from "../../../hooks/useGetPropertyCategory";
import { useModalityBadgeStyle } from "../../../hooks/useAttributeColor";

export const PropertyBadge = (props) => {
  const {
    technicalName,
    value,
    isHighlighted,
    setHighlighted,
    propertyFilter = "",
  } = props;
  const getPropertyCategory = useGetPropertyCategory();
  const category = getPropertyCategory(technicalName);
  const modalityBadgeStyle = useModalityBadgeStyle();

  return (
    <Badge
      className={`property-badge ${category.className} ${
        setHighlighted ? "clickable" : ""
      }`}
      color="invalid" // Programatically set
      style={{
        backgroundColor: category.light,
        outline: isHighlighted ? `3px solid ${category.color}` : "none",
      }}
      onClick={setHighlighted}
    >
      <PropertyName {...props} showIcon highlight={propertyFilter} />
      <span
        className="value"
        style={
          technicalName === MODALITY_PROPERTY
            ? modalityBadgeStyle(value)
            : undefined
        }
      >
        {value == null ? NULL_GROUP_LABEL : truncateNumber(value)}
      </span>
    </Badge>
  );
};

PropertyBadge.propTypes = {
  technicalName: PropTypes.string.isRequired,
  propertyFilter: PropTypes.string,
  isHighlighted: PropTypes.bool,
  setHighlighted: PropTypes.func,
  value: PropTypes.any,
};
